import {Guess, Result, ResultNormalized, Stats, StatsDistribution} from "../types/types";

const RESULT_HISTORY = 'RESULT_HISTORY'

function normalizeResult (result: Result) : ResultNormalized {
	const win = result.guesses.findIndex(x => x.result === 'correct') >= 0
	return {
		...result,
		win,
	}
}

export default function loadStats () {
	let resultHistory : ResultNormalized[] = []
	const loc = localStorage.getItem(RESULT_HISTORY)
	if (!loc) {
		resultHistory = []
	} else {
		try {
			const raw = JSON.parse(loc) as any[]
			resultHistory = raw.map((result) => {
				return normalizeResult(result)
			}).sort((a,b) => {
				return a.date < b.date ? 1 : -1
			})
		} catch (ex) {
			resultHistory = []
		}
	}

	function getGameResult (id: string) : ResultNormalized | undefined {
		return resultHistory.find(x => x.hintId === id)
	}

	function getGuessDistribution () : StatsDistribution {
		const distro : StatsDistribution = {}
		resultHistory.forEach((item) => {
			if (!guessesAreAWin(item.guesses) && item.guesses.length <= 8) {
				return
			}
			const numGuesses = item.guesses.length;
			distro[numGuesses] = distro[numGuesses] || 0
			//@ts-ignore
			distro[numGuesses]++
		})
		return distro
	}

	function guessesAreAWin (guesses: Guess[]) {
		return guesses.findIndex(x => x.result === 'correct') >= 0
	}

	function saveGameResult (id: string, guesses: Guess[]) {
		const idx = resultHistory.findIndex(x => x.hintId === id)
		if (idx >= 0) {
			resultHistory[idx].guesses = guesses
		} else {
			resultHistory.push({
				hintId: id,
				guesses,
				date: new Date(),
				win: guessesAreAWin(guesses),
			})
		}
		saveHistory()
	}

	function saveHistory () {
		const js = JSON.stringify(resultHistory)
		localStorage.setItem(RESULT_HISTORY, js)
	}

	function getWins () : number {
		const wins = resultHistory.filter(x => x.win)
		return wins.length
	}

	function getStreaks () {
		let currentStreak = 0
		let longestStreak = 0
		let onCurrent = true
		let winCount = 0
		resultHistory.forEach((result) => {
			if (result.win) {
				winCount++
			} else {
				if (longestStreak < winCount) {
					longestStreak = winCount
				}

				if (onCurrent) {
					onCurrent = false
					currentStreak = winCount
				}
				winCount = 0
			}
		})
		return {
			longestStreak,
			currentStreak,
		}
	}

	function getStats () : Stats {
		const distributions = getGuessDistribution()
		const {longestStreak, currentStreak} = getStreaks()
		const wins = getWins()
		return {
			distributions,
			currentStreak,
			longestStreak,
			wins,
			played: resultHistory.length,
		}
	}

	return {
		getGameResult,
		saveGameGuesses: saveGameResult,
		getStats,
	}
}
